<template lang="pug">
tr
  td.w-25.text-center
    project-login-button(
      ref="projectLoginButton"
      :project="selectedProject"
      :crd-project="crdProject"
    )
  td.w-75.text-center(
    :style="profileColumnStyle"
  )
    a-select.w-75(
      v-if="showSelect"
      :disabled="loggingIn"
      :show-search="true"
      :default-value="selected"
      :filter-option="handleFilterOption"
      option-filter-prop="children"
      @change="handleChange"
      @click="(e) => e.stopPropagation()"
    )
      a-select-option(
        v-for="option in selectOptions"
        :key="option.value"
        :value="option.value"
        :label="option.label"
      )
        b-badge.w-100(
          :style="{ 'background-color': profileColor(option.profileName, '0.8') }"
        ) {{ `#${option.label}` }}

    b-badge.w-75.mt-1(
      v-else
      :style="selectedProjectProfileNameStyle"
      @click="(e) => e.stopPropagation()"
    ) {{`#${selectedProjectProfileName}`}}

</template>

<script>
import { hexToRgbA } from '@/util';
import ProjectLoginButton from '@/components/ProjectLoginButton';
import { find, isNumber, map, at, orderBy } from 'lodash';
import stc from 'string-to-color';

export default {
  components: {
    ProjectLoginButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    crdProject: {
      type: Object,
      required: false,
      default() { return null; },
    },
  },
  data() {
    return {
      selected: null,
      loggingIn: false,
    };
  },
  computed: {
    showSelect() {
      return this.item.projects.length > 1;
    },
    selectedProject() {
      return find(this.item.projects, ['profiler.id', this.selected]);
    },
    orderedProjects() {
      return orderBy(this.item.projects, project => project.profiler.profileEntity.name, ['asc']);
    },
    selectOptions() {
      return map(this.orderedProjects, project => ({
        profileName: project.profiler.profileEntity.name,
        label: this.getSelectOptionCaption(project),
        value: project.profiler.id,
      }));
    },
    selectedProjectProfileName() {
      return this.selectedProject.profiler.profileEntity.name;
    },
    selectedProjectProfileNameColor() {
      return this.profileColor(this.selectedProjectProfileName, '0.55');
    },
    selectedProjectProfileNameStyle() {
      return {
        color: 'white',
        'font-size': '15px',
        'background-color': this.selectedProjectProfileNameColor,
        'border-radius': '4px',
      };
    },
    profileColumnStyle() {
      return {
        'background-image': `linear-gradient(to right, rgba(255,0,0,0) , ${this.selectedProjectProfileNameColor} )`,
      };
    },
  },
  created() {
    this.selected = this.orderedProjects[0].profiler.id;
  },
  methods: {
    doLogin() {
      this.loggingIn = true;
      this.$refs.projectLoginButton.$el.click();
    },
    handleChange(option) {
      this.selected = option;

      this.$nextTick(() => this.doLogin());
    },
    handleFilterOption(input, option) {
      const [profileName] = at(option, 'componentOptions.propsData.label') || '';

      return profileName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getSelectOptionCaption(project) {
      const { profiler } = project;
      let caption = profiler.profileEntity.name;

      if (isNumber(profiler.organizationId)) {
        caption = `${caption} #${profiler.organizationId}`;
      }

      return caption;
    },
    profileColor(profileName, a = '0.4') {
      return hexToRgbA(stc(profileName), a);
    },
  },
};
</script>
